import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-screen-2xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">精彩推荐</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            编辑团队精心挑选的高分好剧，每一部都值得你的时间
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, index) => (
            <div
              key={item.id}
              className="group relative rounded-xl overflow-hidden bg-background-50 cursor-pointer"
              style={{ animation: `fadeInUp 0.5s ease-out ${index * 0.1}s both` }}
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={index === 0 ? undefined : 'lazy'}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-all duration-300"></div>
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-md bg-accent-500 text-white text-xs font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                    <i className="ri-play-fill text-2xl md:text-3xl"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-3">
                  <span className="text-white font-heading text-lg md:text-xl drop-shadow-lg">{item.heat}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-lg text-foreground-950 mb-1">{item.title}</h3>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{item.category}</span>
                  <span className="text-xs text-foreground-400">{item.episode}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}